import { render } from "./TaxonItem.vue?vue&type=template&id=36944b98&scoped=true"
import script from "./TaxonItem.vue?vue&type=script&lang=js"
export * from "./TaxonItem.vue?vue&type=script&lang=js"

import "./TaxonItem.vue?vue&type=style&index=0&id=36944b98&scoped=true&lang=css"

import exportComponent from "/builds/dlr-pt/rote-liste-zentrum/pwa-kartierung/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36944b98"]])

export default __exports__